import commonConstant from '../../common/_commonConstant';
import { getCookieToken, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history, vehicleLicensePlate } from '../../helpers';
import { fetchRefreshToken } from '..';

export const fetchGetLicensePlate = (buildingIDs, vehicleLicensePlateLike, parkingStatus, parkingRefNoLike, withoutLPRIssues) => ( // Note parkingStatus = IN, OUT
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parkings?buildingIDs=${buildingIDs}${vehicleLicensePlateLike ? `&vehicleLicensePlateLike=${vehicleLicensePlateLike}` : ''}&parkingStatus=${parkingStatus}${parkingRefNoLike ? `&parkingRefNoLike=${parkingRefNoLike}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_LICENSE_PLATE_SUCCESS,
          'data': data.data ? withoutLPRIssues && vehicleLicensePlateLike ? data.data.filter(ele => vehicleLicensePlate(ele) !== '00000') : [...data.data] : [],
          'searchVehicle': vehicleLicensePlateLike ? vehicleLicensePlateLike : parkingRefNoLike ? parkingRefNoLike : null,
          'dateTime': new Date(),
          'status': res.status,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_LICENSE_PLATE_FAILURE,
        'data': null,
        'searchVehicle': vehicleLicensePlateLike ? vehicleLicensePlateLike : parkingRefNoLike ? parkingRefNoLike : null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_LICENSE_PLATE_FAILURE,
        'data': null,
        'searchVehicle': vehicleLicensePlateLike ? vehicleLicensePlateLike : parkingRefNoLike ? parkingRefNoLike : null,
        'status': err.status ? err.status : err,
      });
    }
  }
);

export const fetchSearchVehicleLicensePlate = (vehicleLicensePlateLike) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/vehicles?vehicleLicensePlateLike=${vehicleLicensePlateLike}&limit=50&offset=0`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.SEARCH_CAR_PLATE_SUCCESS,
          'data': data.data ? [...data.data] : [],
          'dateTime': new Date(),
          'status': res.status,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.SEARCH_CAR_PLATE_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_CAR_PLATE_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
      });
    }
  }
);
